// @flow
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import React from 'react';

type Props = {
  options: any,
};

const Highstock = ({ options }: Props) => (
  <HighchartsReact constructorType="stockChart" highcharts={Highcharts} options={options} />
);

Highstock.Highcharts = Highcharts;

export default Highstock;
